import {
  ADD_LIST,
  CLOSE_BOX,
  CLOSE_BOXES,
  CLOSE_OTHER_BOXES,
  INIT_ARTWORK,
  OPEN_BOX,
  SET_BOX_CONTENT,
  SET_ADDING_TO_LIST,
  SET_REMOVING_FROM_LIST,
  SET_CREATING_LIST,
  SET_INPUT_ERROR,
  SET_INPUT_VISIBILITY,
  SET_LISTS,
  SET_USER_ID
} from "./actions";

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_ARTWORK:
      return { ...state, artwork: {} };

    case ADD_LIST:
      return { ...state, lists: [...state.lists, action.payload] };

    case SET_INPUT_ERROR:
      return { ...state, inputError: action.payload };

    case SET_ADDING_TO_LIST: {
      const { listId, adding } = action.payload;
      const listIndex = state.lists.findIndex(list => list.id === listId);
      const newLists = [...state.lists];
      newLists[listIndex].addingToList = adding;
      return { ...state, lists: [...newLists] };
    }

    case SET_REMOVING_FROM_LIST: {
      const { listId, removing } = action.payload;
      const listIndex = state.lists.findIndex(list => list.id === listId);
      const newLists = [...state.lists];
      newLists[listIndex].removingFromList = removing;
      return { ...state, lists: [...newLists] };
    }

    case SET_USER_ID:
      return { ...state, userId: action.payload };

    case SET_LISTS:
      return { ...state, lists: action.payload };

    case OPEN_BOX: {
      const artId = action.payload;
      return state.artwork[artId]
        ? {
            ...state,
            artwork: {
              ...state.artwork,
              [artId]: { ...state.artwork[artId], boxVisible: true }
            }
          }
        : {
            ...state,
            artwork: {
              ...state.artwork,
              [artId]: { boxVisible: true }
            }
          };
    }

    case CLOSE_BOXES: {
      const boxes = Object.keys(state.artwork);
      const newState = Object.assign({}, state);
      boxes.forEach(box => {
        newState.artwork[box].boxVisible = false;
      });
      return newState;
    }

    case CLOSE_OTHER_BOXES: {
      const boxes = Object.keys(state.artwork).filter(
        key => key !== action.payload
      );
      const newState = Object.assign({}, state);
      boxes.forEach(box => {
        newState.artwork[box].boxVisible = false;
      });
      return newState;
    }

    case CLOSE_BOX: {
      const artId = action.payload;
      return state.artwork[artId]
        ? {
            ...state,
            artwork: {
              ...state.artwork,
              [artId]: { ...state.artwork[artId], boxVisible: false }
            }
          }
        : {
            ...state,
            artwork: {
              ...state.artwork,
              [artId]: { boxVisible: false }
            }
          };
    }

    case SET_BOX_CONTENT: {
      const {
        payload: { artId, content }
      } = action;
      return state.artwork[artId]
        ? {
            ...state,
            artwork: {
              ...state.artwork,
              [artId]: {
                ...state.artwork[artId],
                boxContent: content
              }
            }
          }
        : {
            ...state,
            artwork: {
              ...state.artwork,
              [artId]: { boxContent: content }
            }
          };
    }

    case SET_INPUT_VISIBILITY: {
      return { ...state, inputVisible: action.payload };
    }

    case SET_CREATING_LIST: {
      return { ...state, creatingList: action.payload };
    }

    default:
      return state;
  }
};

export default reducer;
